<template>
    <div>

            <div class="baiseback">

                <!-- 左对齐 -->
                <div class="media">
                    <div class="media-left">
                        <img  :src="typeInfo.icon" class="media-object" style="width:60px;margin-right: 20px;">
                    </div>
                    <div class="media-body">

                        <h4 class="media-heading">{{typeInfo.name}}<small class="pull-right typedesc">今日 {{typeInfo.todayForumNum}}，历史 {{typeInfo.historyForumNum}}</small></h4>
                        <p>简介： {{typeInfo.tdesc==''?'暂无':typeInfo.tdesc}}

                        </p>
                        <p>
                            <el-button type="warning" round plain size="mini" class="pull-right" @click="returnforum"><i class="fa fa-rotate-right"></i>返回主题</el-button>

                            <el-button @click="addcyFunc" v-if="typeInfo.addType=='1'||(typeInfo.addType=='2'&&IisFqz)" type="warning" round   size="mini" class="pull-right"><i class="fa fa-plus"></i> 添加成员</el-button>
                            <el-button v-if="typeInfo.createUid!=lander.uid" type="danger" round  size="mini" class="pull-right" @click="IexitTeam">退群</el-button>
                        </p>

                    </div>
                </div>
            </div>
            <div class="baiseback margintop20">
                <el-tabs v-model="activeName"  @tab-click="tabClick">

                    <el-tab-pane v-if="IisFqz" label="管理帖子" name="tz"></el-tab-pane>
                    <el-tab-pane  :label="IisFqz?'管理群成员':'群成员'"    name="cy"></el-tab-pane>
                    <el-tab-pane v-if="IisFqz" label="进群审核" name="sh"></el-tab-pane>
<!--                    <el-tab-pane  label="添加成员" name="addcy" v-if="typeInfo.addType=='1'||(typeInfo.addType=='2'&&IisFqz)"></el-tab-pane>-->

                </el-tabs>
            </div>

        <img src="../../../assets/img/fanhui.png" @click="goreaturn"   class="goreturn hander">
    </div>

</template>
<script>

    import {dealResult, getWindowWidth} from '../../../api/common'
    import {getTypeForumInfo, exitTeam, delTeamerById} from '../../../api';
    import PubSub from "pubsub-js";



    export default {
        name: 'TeamTop',
        components: {


        },

        data() {
            return {
                activeName:'cy',
                webW:true,
                scrolltop:0,
                lander:{},

                IisFqz:false,
                typeInfo:{},

                Team_typeId:'',
            };
        },
        methods: {
            tabClick(tab, event) {
                if(this.activeName=='cy')this.$router.push("Teamer?TeamType=cy&Team_typeId="+this.Team_typeId);
                if(this.activeName=='sh')this.$router.push("Teamer?TeamType=sh&TeamIsagree=0&Team_typeId="+this.Team_typeId);
                if(this.activeName=='tz')this.$router.push("TeamForum?TeamType=tz&Team_typeId="+this.Team_typeId);
                if(this.activeName=='addcy')this.addcyFunc();
            },
            addcyFunc(){
                this.$router.push("TeamerAdd?TeamType=addcy&Team_typeId="+this.Team_typeId);
            },
            goreaturn(){
                this.$router.go(-1);
            },

            returnforum(){
                this.$router.push("Forum?typeId="+this.Team_typeId);
            },



            getTypeForumInfoFunc() {

                getTypeForumInfo({uid: this.lander.uid, token: this.lander.token,typeId:this.Team_typeId}).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.typeInfo=res.data.obj;
                        if(this.typeInfo.type!="sub" ){
                            sessionStorage.systip="该群组不存在";
                            this.$router.replace("/Tip");return;
                        }
                        if(this.typeInfo.type=="sub"&&this.typeInfo.utli!=null){
                            for(let i=0;i<this.typeInfo.utli.length;i++){
                                if(this.lander.uid==this.typeInfo.utli[i].manageUid){
                                    this.IisFqz=true;break;
                                }
                            }
                        }

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })


            },

            IexitTeam() {
                this.$confirm("确定退群", "提示", {
                    type: "warning",
                }) .then(() => {
                    this.loading = this.$loading({
                        lock: true,
                        text: "请求中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.5)",
                    });
                    let o={ typeId:this.Team_typeId,uid:this.lander.uid,token:this.lander.token}
                    exitTeam(o).then((res) => {
                        this.loading.close();
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.info(res.data.msg+",即将返回主页")
                            setTimeout(()=>{
                                this.$router.replace("/Forum");
                            },200)
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })

                });



            },
        }, mounted() {
            this.webW=getWindowWidth()>=1000?true:false;
            this.lander = JSON.parse(this.$store.state.logininfo);

            if(this.$route.query.Team_typeId==undefined) {
                sessionStorage.systip="该群组不存在";
                this.$router.replace("/Tip");return;
            }
            if(this.$route.query.TeamType!=undefined)    this.activeName=this.$route.query.TeamType;

             this.Team_typeId=this.$route.query.Team_typeId;
            this.getTypeForumInfoFunc();




        }, watch:{
            $route:function(value){
                if(value.query.TeamType!=undefined)    this.activeName=value.query.TeamType;
                if(value.query.Team_typeId!=undefined) {
                    this.Team_typeId=value.query.Team_typeId;
                    this.getTypeForumInfoFunc();
                }

            }
        },
        activated() {



        },
        deactivated() {

        }

    };
</script>
<style scoped>
    .touxiangfantt{width: 50px;height: 50px;border-radius: 50%;}

</style>
